import React from 'react';
import { useLanguageDetection } from '../hooks/useLanguageDetection';
import LanguageBanner from './LanguageBanner';

export default function LanguageDetectionGate({ children }) {
    const {
        showBanner,
        showPicker,
        bannerLang,
        setShowPicker,
        confirmLanguage,
        changeLanguage,
        languages,
    } = useLanguageDetection();

    return (
        <>
            {children}
            <LanguageBanner
                visible={showBanner}
                lang={bannerLang}
                showPicker={showPicker}
                languages={languages}
                onConfirm={confirmLanguage}
                onOpenPicker={() => setShowPicker(true)}
                onClosePicker={() => setShowPicker(false)}
                onSelectLanguage={changeLanguage}
            />
        </>
    );
}
